export function stripTrailingSlash(url) {
    return url.replace(/\/$/, '');
}
